<template>
  <div id="mevSettings">
    <div class="section-header">
      <div class="section-title">{{$t('mev_config.configTitle')}}</div>
      <label class="section-description" v-html="$t('mev_config.configSubtitle')"></label>
    </div>
    <div class="columns" v-if="mevConfig">
      <div class="column">
        <div class="group">
          <div class="field-title">
            <label>{{ $t('branch.mev.registeredName')}}</label>
            <tooltip :text="$t('mev_config.tooltips.mandataryName')"></tooltip>
          </div>
          <input type="text" v-model.trim="mevConfig.registeredName" :class="{ invalid: $validate.error('mevConfig.registeredName') }">
        </div>
        <div class="group">
          <div class="field-title">
            <label>{{ $t('branch.mev.identificationNumber')}}</label>
            <tooltip :text="$t('mev_config.tooltips.id')"></tooltip>
          </div>
          <input type="text" v-model.trim="mevConfig.identificationNumber" :class="{ invalid: $validate.error('mevConfig.identificationNumber') }">
        </div>
        <div class="group">
          <div class="field-title">
            <label>{{ $t('branch.mev.billingFileNumber')}}</label>
            <tooltip :text="$t('mev_config.tooltips.fileNo')"></tooltip>
          </div>
          <input type="text" v-model.trim="mevConfig.billingFileNumber" :class="{ invalid: $validate.error('mevConfig.billingFileNumber') }">
        </div>
      </div>
      <div class="column">
        <div class="group">
          <div class="field-title">
            <label>{{ $t('branch.mev.orgName')}}</label>
            <tooltip :text="$t('mev_config.tooltips.org')"></tooltip>
          </div>
          <input type="text" v-model.trim="mevConfig.orgName" :class="{ invalid: $validate.error('mevConfig.orgName') }">
        </div>
        <div class="group">
          <div class="field-title">
            <label>{{ $t('branch.mev.orgUnit')}}</label>
            <tooltip :text="$t('mev_config.tooltips.orgUnit')"></tooltip>
          </div>
          <input type="text" v-model.trim="mevConfig.orgUnit" :class="{ invalid: $validate.error('mevConfig.orgUnit') }">
        </div>
        <div class="group" v-if="atLeastSuperAdmin">
          <label>{{ $t('branch.mev.timeoutForOffline')}} <tag>superadmin</tag></label>
          <input type="number" v-model="mevConfig.timeoutForOffline">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MevSettings",

  props: {
    mevConfig: Object
  },

  computed: {
    atLeastSuperAdmin() {
      return this.$store.getters.loggedUserHasSuperAdmin;
    },
  },

  validate: {
    "mevConfig.registeredName": {
      required: true
    },
    "mevConfig.identificationNumber": {
      required: true
    },
    "mevConfig.billingFileNumber": {
      required: true
    },
    "mevConfig.orgName": {
      required: true
    },
    "mevConfig.orgUnit": {
      required: true
    }
  },

  methods: {
    validateAndSave() {
      if (!this.mevConfig) {
        return;
      }
      if (!this.$validate.valid()) {
        toast(this.$t("branch.error.required"), "warning");
        this.$validate.validateAllOnce();
        return;
      }
      this.$emit("saveConfig")
    }
  }
}
</script>

<style lang="scss" scoped>
.section-header {
  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #1A1A1A;
  }
  .section-description {
    margin-bottom: 40px;
  }
}

.field-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  color: #808080;
  font-size: 14px;
  align-items: center;

  .tooltip {
    margin-left: 4px;
  }
}

</style>